<template>
  <CustomPage
    title="订单详情"
    :subtitle="subtitle"
    :noBorder="true"
    style="background: #f7f7f7"
  >
    <div slot="content">
      <div class="in-sale-container">
        <Header :data="data" />
        <div class="body">
          <AddressPanel :data="data" />
          <MainPanel :data="data" />
          <AmountPanel :data="data" />
        </div>

        <div
          class="footer items-center"
          v-if="
            data && (data.state === 'SHIPPED' || data.state === 'COMPLETED')
          "
        >
          <div
            class="btn van-hairline--surround"
            @click="
              $router.push({ name: 'OrderInSaleLocus', query: { id: orderNo } })
            "
          >
            查看物流
          </div>
        </div>
      </div>

      <CustomView />
    </div>
  </CustomPage>
</template>

<script>
import CustomView from "@/components/custom-view.vue";
import CustomPage from "@/components/custom-page.vue";
import Header from "./components/Header";
import MainPanel from "./components/MainPanel";
import AmountPanel from "./components/AmountPanel";
import AddressPanel from "./components/AddressPanel";
import { getInSaleDetail } from "@/api/order/inSale";
import { areaList } from "@vant/area-data";
export default {
  components: {
    CustomView,
    CustomPage,
    Header,
    MainPanel,
    AmountPanel,
    AddressPanel,
  },
  created() {
    this.detailType = this.$route.params.type;
    this.orderNo = this.$route.params.id;
    this.getData();
  },
  data() {
    return {
      areaList,
      data: {},
      subtitle: "", // "2天21小时44分30秒商家不处理自动退款",
      detailType: "",
      showCancelOrder: false,
      cancelReason: null,
      showPayment: false,
    };
  },
  methods: {
    getData() {
      console.log(222222222229999);
      this.$store.dispatch("app/showLoading");
      getInSaleDetail(this.orderNo)
        .then((res) => {
          this.$store.dispatch("app/hideLoading");
          this.data = this.converData(res.data);
        })
        .catch(() => {
          this.$store.dispatch("app/hideLoading");
        });
    },
    converData(data) {
      const province =
        this.areaList.province_list[data.shippingAddress.province];
      const city = this.areaList.city_list[data.shippingAddress.city];
      const county = this.areaList.county_list[data.shippingAddress.area];
      data.areaName = `${province} ${city} ${county} ${data.shippingAddress.address}`;
      data.recipients = data.shippingAddress.recipients;
      data.recipientsMobile = data.shippingAddress.recipientsMobile;
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
.in-sale-container {
  .body {
    padding: 0 24px;
    margin-top: -98px;
  }
}
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
  padding: 22px 24px 20px;
  .btn {
    font-size: 28px;
    color: #666666;
    line-height: 28px;
    padding: 15px 20px;
    & + .btn {
      margin-left: 20px;
    }
    &::after {
      border-radius: 56px;
      border-color: #979797;
    }
  }
}
</style>
